module.exports = __webpack_public_path__ + "static/img/curved9.b94cc693.jpg";